<template>
    <div class="max-w-7xl mx-auto mt-auto h-12 w-full px-2">
        <div
            class="flex flex-col md:flex-row items-stretch lg:justify-between lg:items-center gap-4"
        >
            <div
                class="text-xs text-gray-500 order-2 md:order-1 flex flex-col md:flex-row items-start md:items-center gap-x-2"
            >
                <span>
                    {{ appName }} {{ currentYear }}.
                    {{ localizer.translate(TextTokenEnum.AllRightsReserved) }}.
                </span>
                <span class="hidden md:block">|</span>
                <span>
                    <a
                        :id="openCookieSettingsElementId"
                        href="javascript:void(0)"
                    >
                        Cookie Preferences
                    </a>
                </span>
            </div>
            <div class="order-1 md:order-2">
                <slot name="right" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import useDate from '@/Shared/Hook/useDate'
    import LocalizerService from '@/Shared/Service/Localization/LocalizerService'
    import {
        TextTokenEnum,
        type LocaleEnum,
    } from '@/Shared/AutoGenerated/LocalizationEnum'

    interface FooterProps {
        appName: string
        currentLocale: LocaleEnum
        openCookieSettingsElementId: string
    }

    const props = defineProps<FooterProps>()
    const currentYear = useDate().getCurrentYear()

    const localizer = LocalizerService.make(props.currentLocale)
</script>
